import { notify } from 'utils/reduxUtils';

export const types = {
  SEND_INVITES_MODAL_OPEN: 'modals/inviteModal/SEND_INVITES_MODAL_OPEN',
  SEND_INVITES_MODAL_CLOSE: 'modals/inviteModal/SEND_INVITES_MODAL_CLOSE',
  SEND_INVITES_ERROR: 'modals/inviteModal/SEND_INVITES_ERROR',
  SEND_INVITES_SUCCESS: 'modals/inviteModal/SEND_INVITE_SUCCESS',
  SEND_INVITES_REQUEST: 'modals/inviteModal/SEND_INVITE_REQUEST',
  INVITES_SENT_MODAL_CLOSE: 'modals/inviteModal/INVITES_SENT_MODAL_CLOSE',
  INVITES_SKIPPED_MODAL_CLOSE:
    'modals/invitesModal/INVITES_SKIPPED_MODAL_CLOSE',
};

export const sendInvitesModal = {
  open: () => ({
    type: types.SEND_INVITES_MODAL_OPEN,
  }),
  close: () => ({
    type: types.SEND_INVITES_MODAL_CLOSE,
  }),
};

export const invitesSentModal = {
  close: () => ({
    type: types.INVITES_SENT_MODAL_CLOSE,
  }),
};

export const invitesSkippedModal = {
  close: () => ({
    type: types.INVITES_SKIPPED_MODAL_CLOSE,
  }),
};

export const sendInvites = {
  error: notify(
    (error) => ({
      type: types.SEND_INVITES_ERROR,
      payload: error,
    }),
    'Failed to send one or more invites',
  ),
  request: ({ emailAddresses }) => ({
    type: types.SEND_INVITES_REQUEST,
    payload: { emailAddresses },
  }),
  success: () => ({
    type: types.SEND_INVITES_SUCCESS,
  }),
};
